<template>
    <div class='register'>
        <el-form
            :model="loginForm"
            label-width="120px"
            :rules="loginRules"
            auto-complete="on"
            label-position="right"
            ref="loginForm">

            <h3 style='fontSize: 20px;textAlign:center'>注册</h3>

            <!-- 登录账号 -->
            <el-form-item label="登录账号" prop='email'>
                <el-input v-model="loginForm.email" placeholder="请输入邮箱"></el-input>
                <el-button style='float:right' type="primary" :disabled='this.vcodebtn' @click="openEmail">{{verification}}</el-button>
            </el-form-item>

            <!-- 登录密码 -->
            <el-form-item label="登录密码" prop='password'>
                <el-input type="password" v-model="loginForm.password" placeholder="密码不小于五位"></el-input>
            </el-form-item>

            <!-- 确认密码 -->
            <el-form-item label="确认密码" prop='checkPass'>
                <el-input type="password" v-model="loginForm.checkPass" placeholder="请再次输入密码"></el-input>
            </el-form-item>

            <!-- 验证码 -->
            <el-form-item label="验证码" prop='vcode'>
                <el-input v-model="loginForm.vcode" placeholder="请输入验证码"></el-input>
            </el-form-item>

            <!-- 中文名 -->
            <el-form-item label="中文名" prop='cnname'>
                <el-input v-model="loginForm.cnname" placeholder="请输入中文名"></el-input>
            </el-form-item>

            <!-- 性别 -->
            <el-form-item label="性别" prop='gender'>
                <el-radio-group v-model="loginForm.gender">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
            
            <!-- 员工编号 -->
            <el-form-item label="员工编号" prop='employee_no'>
                <el-input v-model="loginForm.employee_no" placeholder="请输入员工编号"></el-input>
            </el-form-item>

            <!-- 手机号 -->
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="loginForm.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
        </el-form>
        <div class='submintbtn'>
            <el-button type="primary" @click='submint' :loading="loading">注册</el-button>
            <el-button type="primary" @click="cancel">取消</el-button>
        </div>
    </div>
       
</template>

<script>
import { userSendemail, userRegister } from '../../services/login/register'
export default {
    data() {
        const validatePass = (rule, value, callback) => {
            if (value) {
                if (value.length < 5) {
                    callback(new Error('密码不能小于5位'))
                } else {
                    callback()
                }
            } else {
                    callback(new Error('密码不能为空'))
            }
            
        };
        const validatetel = (rule, value, callback) => {
            let reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/
            if (reg.test(value)){
                callback()
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        const validateAgainPass = (rule, value, callback) => {
            if (value) {
                if (this.loginForm.password === value) {
                    callback()
                } else {
                    callback(new Error('输入密码错误'))
                }
            } else {
                callback(new Error('请再次输入密码'))
            }
        };
        return {
            formName: "loginForm",
            loginForm: {},
            loginRules: {
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' }
                ],
                password: [{required: true, trigger: 'blur', validator: validatePass}],
                checkPass: [{required: true, trigger: 'blur', validator: validateAgainPass}],
                mobile: [
                    {required: true, trigger: 'blur', validator: validatetel}
                ],
                vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                cnname: [{ required: true, message: '请输入中文名', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
                employee_no: [{ required: true, message: '请输入员工编号', trigger: 'blur' }]
            },
            vcodebtn: false,
            loading: false,
            verification: '发送验证码',
            disabled: false,
            timer: null,
        }
    },
    methods: {
        openEmail() { // 发送验证码
            if (this.loginForm.email) {
                let params = {
                    email: this.loginForm.email
                }
                userSendemail(params).then(
                    res => this.$message.success(res.message),
                    err => this.$message.error(err.message)
                )
                this.vcodebtn = true;
                this.auth_time = 60;
                this.verification = '已发送('+ this.auth_time  +')'
                this.timer =  setInterval(() => {
                    this.auth_time--;
                    this.verification = '已发送('+ this.auth_time  +')'
                    if(this.auth_time <= 0){
                        this.vcodebtn = false;
                        this.verification = '发送验证码'
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.$message.error('请输入邮箱')
            }
                
        },
        submint() { // 点击注册
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    userRegister(this.loginForm).then(
                        res => {
                            this.$message.success('注册成功')
                            this.$emit('changetitle', 'login')
                            this.loading = false
                        },
                        err => this.$message.error(err.message)
                    )
                } else {
                    return false
                }
            })
        },
        cancel() {
            this.loginForm = {}
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" <style lang="scss" scoped>
    /deep/ .el-form {
        position: relative;
        margin-top: 20px;
        .el-form-item__label {
            font-size: 20px;
        }
        .el-form-item {
            font-size: 18px;
            margin-top: 20px;
            .el-input--mini {
                font-size: 18px;
            }
            .el-form-item__content {
                .el-radio-group{
                    .el-radio {
                        -webkit-backface-visibility: hidden;
                    }
                }
            }
        }
        .el-button {
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    // .submintbtn {
    //     margin-top: 100px;
    //     text-align: center;
    //     /deep/ .el-button {
    //         width: 150px;
    //     }
    // }
    @media screen and (max-width: 1500px) {
        /deep/ .el-form {
            position: relative;
            .el-form-item__label {
                font-size: 16px;
            }
            .el-form-item {
                font-size: 16px;
                .el-input--mini {
                    font-size: 14px;
                }
                .el-form-item__content {
                    .el-radio-group{
                        .el-radio {
                            -webkit-backface-visibility: hidden;
                        }
                    }
                }
            }
        }
        .submintbtn {
            margin: none;
            text-align: center;
            /deep/ .el-button {
                width: 150px;
            }
        }
    }
    @media screen and (min-width: 1500px) {
        .submintbtn {
            margin: none;
            text-align: center;
            /deep/ .el-button {
                width: 150px;
            }
        }
    }
</style>
